import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import CustomerForm from "../../CustomerForm";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { Controller, useForm } from "react-hook-form";
import NumberInput from "components/GenericComponent/NumberInput";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import NumberFormat from "react-number-format";
import { formatNumber, formatMoney } from "utils/currencyFormat";
import ListTaiSanForm from "../../ListTaiSanForm";
import UploadMultiFile from "components/GenericComponent/UploadMultiFile";
import UploadMultiFile1 from "components/GenericComponent/UploadMultiFile1";
import { tinhNgayTraGocv3 } from "utils/choVayUtils";
import NumberField from "components/GenericComponent/NumberField";
import choVayConst, {
  bindKieuLaiSuat,
  bindTypePaid,
} from "constants/choVayConst";
import ControllerTextInputTwoRow from "components/GenericComponent/ControllerTextInputTwoRow";
import ConfigConst from "constants/ConfigConst";
import { formatDayMonth } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import CamDoApi from "../../../../../../../service/camDoApi";
import ThuocTinhGiamTruModal from "./thuocTinhGiamTru";
import { pushNotification } from "utils/notifications";
const ChoVayForm = (props) => {
  let {
    show,
    customer,
    getAutocompleteCustomer,
    user,
    phikhac,
    phikhachangky,
    getThuocTinhTaiSan1,
    thuoctinhtaisan,
    store,
    nguonkhachhang,
    postCamDo,
    onHide,
    cauhinh,
    getDetailCustomer,
    getThuocTinhTaiSanTMCD,
    themmoicamdo,
    setTaiSanCamCo,
    setListTaiSanCamCo,
    setChoVayEdit,
    getConfigSysTMCD,
    setThuocTinhTaiSan,
    phanquyen,
    showModalLoaiTaiSan,
    inHopDong,
    inPhieuThu,
    checkEditCustomer,
    setEnableEditCustomer,
    getDetailCustomerSuccess,
    quanlycuahang,
    isDuDungPhiPhatDongLaiTatToan,
    SuDungPhiPhat_DongLai_Cham,
    isSuDungTatToanSom,
    isSuDungCongTacVienNhanVien,
  } = props;
  let { comboNguonKhachHang } = nguonkhachhang;
  let {
    ThuocTinhTaiSan,
    TaiSanCamCo,
    ListTaiSanCamCo,
    ConfigTMCD,
    ListLoaiTaiSan,
    choVayEdit,
    setListPhiKhac,
    postCamDoLoading,
    postCamDoReturn,
  } = themmoicamdo;
  let { objConfig } = cauhinh;

  let objConfigSysLoaiTS = ConfigTMCD;
  let {
    LaiSuat,
    TypePaid,
    ChoVayId,
    CountTypePaid,
    BeforeAfter,
    NgayVay,
    KieuLaiSuat,
    Sotienvay,
    SoLanTra,
    SoNgayToiThieu,
    SoNgayGiaHan,
    PhiDongLaiCham,
    CustomerID,
    Note,
    NgayTra,
    TongNgayVay,
    IsCopy,
    showButtonIn,
    showButtonInPhieuThu,
    ThuChiId,
    IsEditChoVay,
    IsEditCustomer,
    Code,
    BocTrongVong,
    ChiPhiVay,
    PhiThanhToanSom,
    PhiBaoHiem,
    IsDuNoGiamDan,
    NgayThanhToan,
    PhiPhatTraLai,
    LoaiPhiPhatTraLai,
    PhiPhatTatToan,
    LoaiPhiPhatTatToan,
    MaNhanVien,
  } = choVayEdit;
  let { LinkDinhKem } = props.data;
  IsEditChoVay = !IsEditChoVay;
  //alert(IsEditChoVay);
  console.log(IsEditChoVay);
  if (choVayEdit.IsCopy) IsEditChoVay = false;
  const [isLoad, setIsLoad] = useState(false);

  const [imageTaiSans, setImageTaiSans] = useState([]);
  const [fileDinhKems, setFileDinhKems] = useState([]);
  const [linkDinhKem, setLinkDinhKem] = useState("");
  const [currentChoVay, setCurrentChoVay] = useState({});
  const [TenTaiSan1, setTenTaiSan1] = useState(null);
  const [currentCode, setCode] = useState(null);
  const [isSetPhiKhac, setIsSetPhiKhac] = useState(null);
  const [isSetPhiKhacHangKy, setIsSetPhiKhacHangKy] = useState(null);
  const [isDuNoGiamDan, setIsDuNoGiamDan] = useState(true);
  const [ChonLoaiPhiKhac, setChonLoaiPhiKhac] = useState(false);
  const [ChonLoaiPhiKhacHangKy, setChonLoaiPhiKhacHangKy] = useState(false);
  const [intLoaiPhiPhatTraLai, setLoaiPhiPhatTraLai] = useState(1);
  const [intLoaiPhiPhatTatToan, setLoaiPhiPhatTatToan] = useState(1);

  const [ListHangSanXuat, setListHangSanXuat] = useState([]);
  const [HangSanXuat, setHangSanXuat] = useState(0);
  const [ListDongSanPham, setListDongSanPham] = useState([]);
  const [DongSanPham, setDongSanPham] = useState(0);
  const [ListNamSanXuat, setListNamSanXuat] = useState([]);
  const [NamSanXuat, setNamSanXuat] = useState("0");
  const [ListSanPham, setListSanPham] = useState([]);
  const [SanPham, setSanPham] = useState(0);
  const [GiaSanPham, setGiaSanPham] = useState(0);
  const [ListGoiVay, setListGoiVay] = useState([]);
  const [GoiVay, setGoiVay] = useState(0);
  const [GiaGoiVay, setGiaGoiVay] = useState(0);
  const [useDuNoGiamDan, setUseDuNoGiamDan] = useState(false);
  const [useThamDinhTaiSan, setUseThamDinhTaiSan] = useState(false);
  const [isShowModalThuocTinhGiamTru, setShowModalThuocTinhGiamTru] =
    useState(false);
  const [ListThuocTinhGiamTru, setListThuocTinhGiamTru] = useState([]);
  const [ListThuocTinhGiamTruSelect, setListThuocTinhGiamTruSelect] = useState(
    [],
  );
  const [dataGoiVay, setDataGoiVay] = useState({});
  const [TongTienGiamTruSelect, setTongTienGiamTruSelect] = useState(0);
  const [useGoiVay, setUseGoiVay] = useState(false);
  let currentForm = useForm({
    CountTypePaid: CountTypePaid,
    Sotienvay: Sotienvay,
    SoLanTra: SoLanTra,
    SoNgayToiThieu: SoNgayToiThieu,
    SoNgayGiaHan: SoNgayGiaHan,
    PhiDongLaiCham: PhiDongLaiCham,
  });
  const { register, handleSubmit, errors, control, setValue } = currentForm; // initialize the hook
  let { objListPhiKhac } = phikhac;
  let { objListPhiKhacHangKy } = phikhachangky;
  let { CategoryId, TenTaiSan, StoreID, PhiKho, LoaiTaiSan, AnhTaiSan } =
    TaiSanCamCo;
  let { thongTinCuaHang } = quanlycuahang ? quanlycuahang : {};
  useEffect(() => {
    if (choVayEdit.ChoVayId > 0) {
      if (
        (choVayEdit.IsDuNoGiamDan != undefined &&
          choVayEdit.IsDuNoGiamDan != isDuNoGiamDan) ||
        isDuNoGiamDan == false
      ) {
        setIsDuNoGiamDan(choVayEdit.IsDuNoGiamDan);
      }
      setLoaiPhiPhatTraLai(choVayEdit.LoaiPhiPhatTraLai);
      setLoaiPhiPhatTatToan(choVayEdit.LoaiPhiPhatTatToan);
    }

    if (choVayEdit.NgayThanhToan === undefined) {
      if (choVayEdit.DatePaid == undefined)
        choVayEdit.NgayThanhToan = choVayEdit.NgayVay;
      else choVayEdit.NgayThanhToan = choVayEdit.DatePaid;
    }

    if (currentChoVay.CountTypePaid !== CountTypePaid) {
      setValue("CountTypePaid", CountTypePaid);
      currentChoVay.CountTypePaid = CountTypePaid;
    }
    if (currentChoVay.LaiSuat !== LaiSuat) {
      setValue("LaiSuat", LaiSuat);
      currentChoVay.LaiSuat = LaiSuat;
    }
    if (currentChoVay.TypePaid !== TypePaid) {
      setValue("TypePaid", TypePaid);
      currentChoVay.TypePaid = TypePaid;
    }
    if (currentChoVay.KieuLaiSuat !== KieuLaiSuat) {
      setValue("KieuLaiSuat", KieuLaiSuat);
      currentChoVay.KieuLaiSuat = KieuLaiSuat;
    }
    if (
      currentChoVay.CountTypePaid !== CountTypePaid ||
      currentChoVay.LaiSuat !== LaiSuat ||
      currentChoVay.TypePaid !== TypePaid ||
      currentChoVay.KieuLaiSuat !== KieuLaiSuat
    )
      setCurrentChoVay(currentChoVay);
    if (
      (Code && Code !== currentCode) ||
      (showButtonIn && currentCode === null)
    ) {
      setValue("Code", Code);
      setCode(Code);
    }
    if (TenTaiSan !== TenTaiSan1) {
      setTenTaiSan1(TenTaiSan);
      setValue("ListHangTheChap[0].TenTaiSan", TenTaiSan);
      setImageTaiSans(AnhTaiSan ? AnhTaiSan.split(";") : []);
    }

    if (
      !isSetPhiKhac &&
      objListPhiKhac.length > 0 &&
      objListPhiKhac[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhac(true);
      for (let index = 0; index < objListPhiKhac.length; index++) {
        const element = objListPhiKhac[index];
        setValue("ListPhiKhac[" + index + "].GiaTri", element.GiaTri);
        setValue("ListPhiKhac[" + index + "].LoaiPhiKhac", element.LoaiPhiKhac);
        setValue(
          "ListPhiKhac[" + index + "].LoaiPhiKhacChon",
          element.LoaiPhiKhacChon,
        );
      }
    }

    if (
      !isSetPhiKhacHangKy &&
      objListPhiKhacHangKy.length > 0 &&
      objListPhiKhacHangKy[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhacHangKy(true);
      for (let index = 0; index < objListPhiKhacHangKy.length; index++) {
        const element = objListPhiKhacHangKy[index];
        setValue("ListPhiKhacHangKy[" + index + "].GiaTri", element.GiaTri);
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKy",
          element.LoaiPhiKhacHangKy,
        );
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKyChon",
          element.LoaiPhiKhacHangKyChon,
        );
      }
    }

    if (linkDinhKem != LinkDinhKem) {
      setFileDinhKems(LinkDinhKem ? LinkDinhKem.split(";") : []);
      setLinkDinhKem(LinkDinhKem);
    }
    if (isLoad == false) {
      if (ListGoiVay.length === 0 && choVayEdit.ChoVayId == 0) {
        getGoiVay(0);
      }
      if (choVayEdit.ChoVayId > 0) {
        loadThamDinhTaiSanTheoChoVay(choVayEdit.ChoVayId);
      }

      CamDoApi.getConfigCamDo("SUDUNG_DUNOGIAMDAN").then((response) => {
        setUseDuNoGiamDan(response.data.Result);
      });

      CamDoApi.getConfigCamDo("SUDUNG_THAMDINHTAISAN").then((response) => {
        setUseThamDinhTaiSan(response.data.Result);
      });
      setIsLoad(true);
    }

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onHide(); // Gọi hàm đóng popup
      }
    };

    // Thêm sự kiện lắng nghe khi component được mount
    document.addEventListener("keydown", handleEscape);

    // Dọn dẹp sự kiện khi component unmount
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onHide]);

  let NoteTaiSan = TaiSanCamCo.Note;
  let MaTaiSan = TaiSanCamCo.Code;

  const onChangDuNoGiamDan = (evt) => {
    setIsDuNoGiamDan(evt.target.checked);
  };
  const onChangeAttNumberChoVay = (field) => (evt) => {
    choVayEdit[field] = evt.target.value;
    setChoVayEdit(choVayEdit);
  };
  const onChangeAttTextChoVay = (field) => (evt) => {
    choVayEdit[field] = evt.target.value;
    setChoVayEdit(choVayEdit);
  };
  const onChangeTypePaid = () => (evt) => {
    choVayEdit.TypePaid = evt.target.value;
    if (!ChoVayId)
      if (evt.target.value === "1") {
        setValue("LaiSuat", ConfigTMCD._laiSuatTinChapCamDoNgay);
      } else {
        setValue("LaiSuat", ConfigTMCD._laiSuatTinChapCamDoThang);
      }
    setChoVayEdit(choVayEdit);
  };
  let { PhanQuyenCamDo } = phanquyen;
  let { chonngaygiaodich, camdo_sudungchoduyet } = PhanQuyenCamDo;
  let { OptionTinhLai, IsTongSoNgay } = objConfig;

  const onSubmit = (dataChoVay) => {
    if (!IsEditChoVay) {
      let x = tinhNgayTraGocv3(
        parseInt(dataChoVay.SoLanTra),
        parseInt(dataChoVay.TongNgayVay),
        parseInt(dataChoVay.CountTypePaid),
        dataChoVay.NgayVay,
        parseInt(dataChoVay.TypePaid),
        1,
        false,
        dataChoVay.NgayTra,
        IsTongSoNgay,
        true,
      );
      dataChoVay.TongNgayVay = x.TongSoNgayVay;
      dataChoVay.NgayTra = x.NgayTraGoc;
      dataChoVay.SoLanTra = x.SoLanTra;
    } else {
      dataChoVay.NgayTra = formatDayMonth(NgayTra);
      dataChoVay.NgayVay = formatDayMonth(NgayVay);
      dataChoVay.SoLanTra = SoLanTra;
      dataChoVay.TypePaid = TypePaid;
    }
    let listTSpost = ListTaiSanCamCo.slice();
    if (dataChoVay.ListHangTheChap[0])
      listTSpost.unshift(dataChoVay.ListHangTheChap[0]);
    dataChoVay.ListHangTheChap[0].AnhTaiSan = imageTaiSans
      .map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      })
      .join(";");
    dataChoVay.FileDinhKems = fileDinhKems
      .map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      })
      .join(";");
    if (choVayEdit.IsCopy) dataChoVay.Code = "";
    dataChoVay.IsDuNoGiamDan = isDuNoGiamDan;
    dataChoVay.LoaiPhiPhatTraLai = choVayEdit.LoaiPhiPhatTraLai;
    dataChoVay.LoaiPhiPhatTatToan = choVayEdit.LoaiPhiPhatTatToan;
    dataChoVay.MaNhanVien = choVayEdit.MaNhanVien;
    var ChoVayThamDinhTaiSan1 = {
      GoiVayId: GoiVay,
      HangSanXuatID: HangSanXuat,
      DongSanPhamID: DongSanPham,
      NamSanXuat: NamSanXuat,
      SanPhamID: SanPham,
      GiaSanPhamSauTru: GiaSanPham,
      GiaGoiVaySauTru: GiaGoiVay,
      LoaiTaiSanID: TaiSanCamCo.LoaiTaiSan,
    };
    var ListChoVayThuocTinhGiamTru = ListThuocTinhGiamTruSelect;
    postCamDo({
      ChoVay: dataChoVay,
      ListHangTheChap: listTSpost,
      Customer: dataChoVay.customer,
      IsChoDuyet: camdo_sudungchoduyet,
      IsCopy: choVayEdit.IsCopy ? choVayEdit.IsCopy : false,
      ChoVayThamDinhTaiSan: ChoVayThamDinhTaiSan1,
      ListChoVayThuocTinhGiamTru: ListChoVayThuocTinhGiamTru,
    });
  };
  const [showAddNewTaiSan, setShowAddNewTaiSan] = useState(false);
  const onClickShowAddNewTaiSan = () => {
    setShowAddNewTaiSan(!showAddNewTaiSan);
  };
  const onChangeLoaiTaiSan = (evt) => {
    let loaiTaiSan = evt.target.value;
    TaiSanCamCo.LoaiTaiSan = loaiTaiSan;
    getConfigSysTMCD({
      loaiTaiSan,
    });
    setTaiSanCamCo(TaiSanCamCo);
    getThuocTinhTaiSanTMCD({ loaiTaiSan });
    getHangSanXuat(loaiTaiSan, 0);
  };

  const onChangeListTaiSan = (listTaiSan) => {
    setListTaiSanCamCo(listTaiSan);
  };
  const onChangeNgayVay = (evt) => {
    choVayEdit.NgayVay = evt;
    if (isDuNoGiamDan === true) {
      choVayEdit.NgayThanhToan = evt;
    }
    setChoVayEdit(choVayEdit);
  };
  const onChangeNgayTra = (evt) => {
    choVayEdit.NgayTra = evt;
    setChoVayEdit(choVayEdit);
  };
  const onChangePhiKhac = (configId) => (evt) => {
    objListPhiKhac[configId].GiaTri = evt.value;
    setListPhiKhac(objListPhiKhac);
  };

  const onChangeLoaiPhiKhac = (configId, val) => (evt) => {
    objListPhiKhac[configId].LoaiPhiKhacChon = val;
    if (setListPhiKhac != undefined) setListPhiKhac(objListPhiKhac);
    setChonLoaiPhiKhac(!ChonLoaiPhiKhac);
  };

  const onChangePhiKhacHangKy = (configId) => (evt) => {
    objListPhiKhacHangKy[configId].GiaTri = evt.value;
  };

  const onChangeLoaiPhiKhacHangKy = (configId, val) => (evt) => {
    objListPhiKhacHangKy[configId].LoaiPhiKhacHangKyChon = val;
    setChonLoaiPhiKhacHangKy(!ChonLoaiPhiKhacHangKy);
  };

  const onChangeLoaiPhiPhatTraLai = (val) => (evt) => {
    setLoaiPhiPhatTraLai(val);
    choVayEdit.LoaiPhiPhatTraLai = val;
    setChoVayEdit(choVayEdit);
  };

  const onChangeLoaiPhiPhatTatToan = (val) => (evt) => {
    setLoaiPhiPhatTatToan(val);
    choVayEdit.LoaiPhiPhatTatToan = val;
    setChoVayEdit(choVayEdit);
  };

  const onChangeThuocTinhTaiSan = (configId) => (evt) => {
    ThuocTinhTaiSan[configId].OptionValue = evt.target.value;
    setThuocTinhTaiSan(ThuocTinhTaiSan);
  };

  const onChangeNgayThanhToan = (evt) => {
    choVayEdit.NgayThanhToan = evt;
    setChoVayEdit(choVayEdit);
  };

  const setAttTaiSan = (field) => (evt) => {
    TaiSanCamCo[field] = evt.target.value;
    setTaiSanCamCo(TaiSanCamCo);
  };
  const closeThemMoi = () => () => {
    setTaiSanCamCo({});
    setListTaiSanCamCo([]);
    getDetailCustomerSuccess({});
    onHide();
  };
  let { autocompleteData } = customer;
  let { combo } = user;
  let { objComboStore } = store;

  let ConfigPhiKho = objConfig.PhiKho;
  let { IsGiaHanTuDong, IsSoNgayTatToan } = ConfigTMCD;

  if (postCamDoReturn) {
    setTaiSanCamCo({});
    setListTaiSanCamCo([]);
    getDetailCustomerSuccess({});
    onHide();
  }

  const loadThamDinhTaiSanTheoChoVay = (chovayId) => {
    CamDoApi.getThamDinhTaiSanTheoChoVay(chovayId).then((response) => {
      console.log("loadThamDinhTaiSanTheoChoVay", response.data);
      if (response.data.DataThamDinh.length > 0) {
        var dataThamDinh = response.data.DataThamDinh[0];
        var listGiamTru = response.data.ListThuocTinhGiamTru;
        LoaiTaiSan = dataThamDinh.LoaiTaiSanID;
        getHangSanXuat(dataThamDinh.LoaiTaiSanID, dataThamDinh.HangSanXuatID);
        getDongSanPham(
          dataThamDinh.LoaiTaiSanID,
          dataThamDinh.HangSanXuatID,
          dataThamDinh.DongSanPhamID,
        );
        getNamSanXuat(
          dataThamDinh.LoaiTaiSanID,
          dataThamDinh.DongSanPhamID,
          dataThamDinh.NamSanXuat,
        );
        getSanPham(
          dataThamDinh.LoaiTaiSanID,
          dataThamDinh.DongSanPhamID,
          dataThamDinh.NamSanXuat,
          dataThamDinh.SanPhamID,
        );
        getDanhSachThuocTinhGiamTru(dataThamDinh.SanPhamID);
        getGoiVay(dataThamDinh.GoiVayId);
        setGoiVay(dataThamDinh.GoiVayId);
        setGiaGoiVay(dataThamDinh.GiaGoiVaySauTru);
        setGiaSanPham(dataThamDinh.GiaSanPhamSauTru);
        setListThuocTinhGiamTruSelect(listGiamTru);
      }
    });
  };

  const getHangSanXuat = (loaiTaiSan, selectId) => {
    CamDoApi.getHangSanXuat(loaiTaiSan).then((response) => {
      setListHangSanXuat(response.data.List);
      if (response.data.List.length > 0) {
        if (selectId == 0) {
          setHangSanXuat(response.data.List[0].Id);
          getDongSanPham(loaiTaiSan, response.data.List[0].Id, 0);
        } else {
          setHangSanXuat(selectId);
        }
      }
    });
  };

  const getDongSanPham = (loaiTaiSan, hangSanXuat, selectId) => {
    CamDoApi.getDongSanPham(loaiTaiSan, hangSanXuat).then((response) => {
      setListDongSanPham(response.data.List);
      if (response.data.List.length > 0) {
        if (selectId > 0) setDongSanPham(selectId);
        else {
          setDongSanPham(response.data.List[0].Id);
          getNamSanXuat(loaiTaiSan, response.data.List[0].Id);
        }
      }
    });
  };

  const getNamSanXuat = (loaiTaiSan, dongSanPham, selectId) => {
    CamDoApi.getNamSanXuat(loaiTaiSan, dongSanPham).then((response) => {
      setListNamSanXuat(response.data.List);
      if (response.data.List.length > 0) {
        if (selectId == 0) {
          setNamSanXuat(response.data.List[0].Id);
          getSanPham(loaiTaiSan, DongSanPham, response.data.List[0].Id, 0);
        } else {
          setNamSanXuat(selectId);
        }
      }
    });
  };

  const getSanPham = (loaiTaiSan, dongSanPham, namSanXuat, selectId) => {
    CamDoApi.getSanPham(loaiTaiSan, dongSanPham, namSanXuat).then(
      (response) => {
        setListSanPham(response.data.List);
        if (response.data.List.length > 0) {
          if (selectId > 0) {
            setSanPham(selectId);
          } else {
            setSanPham(response.data.List[0].Id);
          }
        }
      },
    );
  };

  const onChangeHangSanXuat = (evt) => {
    let hangSanXuat = evt.target.value;
    setHangSanXuat(hangSanXuat);
    getDongSanPham(LoaiTaiSan, hangSanXuat, 0);
  };

  const onChangeDongSanPham = (evt) => {
    let dongSanPham = evt.target.value;
    setDongSanPham(dongSanPham);
    getNamSanXuat(LoaiTaiSan, dongSanPham, 0);
  };

  const onChangeNamSanXuat = (evt) => {
    let namSanXuat = evt.target.value;
    setNamSanXuat(namSanXuat);
    getSanPham(LoaiTaiSan, DongSanPham, namSanXuat, 0);
  };

  const onChangeSanPham = (evt) => {
    let sanPham = evt.target.value;
    setSanPham(sanPham);
    getChiTietSanPham(sanPham);
  };

  const getChiTietSanPham = (sanPham) => {
    CamDoApi.chitietSanPham(sanPham).then((response) => {
      var sanPhamDetail = response.data.Data;
      setListThuocTinhGiamTruSelect([]);
      setGiaGoiVay(GiaGoiVay + parseFloat(TongTienGiamTruSelect));
      setTongTienGiamTruSelect(0);

      if (sanPhamDetail.length > 0) {
        TaiSanCamCo["TenTaiSan"] = sanPhamDetail[0].Ten;
        setTaiSanCamCo(TaiSanCamCo);
        setGiaSanPham(parseFloat(sanPhamDetail[0].Gia));
        getDanhSachThuocTinhGiamTru(sanPhamDetail[0].ThongTinGiamTruID);
      } else {
        TaiSanCamCo["TenTaiSan"] = "";
        setTaiSanCamCo(TaiSanCamCo);
        setGiaSanPham(0);
        getDanhSachThuocTinhGiamTru(0);
      }
    });
  };

  const getGoiVay = (selectId) => {
    CamDoApi.getGoiVay().then((response) => {
      setListGoiVay(response.data.List);
      if (selectId > 0) {
        setGoiVay(selectId);
      } else {
        if (response.data.List.length > 0) {
          setGoiVay(response.data.List[0].Id);
        }
      }
    });
  };

  const onChangeGoiVay = (evt) => {
    let goivay = evt.target.value;
    setGoiVay(goivay);
    getChiTietGoiVay(goivay);
  };
  const getChiTietGoiVay = (goivay) => {
    CamDoApi.chitietGoiVay(goivay).then((response) => {
      var goivayDetail = response.data.Data;
      if (goivayDetail.length > 0) {
        if (goivayDetail[0].LaiSuat > 0) {
          if (goivayDetail[0].KyDongLai != null)
            choVayEdit.CountTypePaid = goivayDetail[0].KyDongLai;

          if (goivayDetail[0].LaiSuat != null)
            choVayEdit.LaiSuat = goivayDetail[0].LaiSuat;

          if (goivayDetail[0].SoLanTra != null)
            choVayEdit.SoLanTra = goivayDetail[0].SoLanTra;

          if (goivayDetail[0].KyDongLaiLoai != null)
            choVayEdit.TypePaid = goivayDetail[0].KyDongLaiLoai;

          if (goivayDetail[0].LaiSuatKieu != null)
            choVayEdit.KieuLaiSuat = goivayDetail[0].LaiSuatKieu;
          setValue("SoLanTra", choVayEdit.SoLanTra);
          setChoVayEdit(choVayEdit);
          if (goivayDetail[0].LoaiGoiVay == "TheChap") {
            setGiaGoiVay(
              parseFloat((goivayDetail[0].HanMucGoiVay * GiaSanPham) / 100) -
                parseFloat(TongTienGiamTruSelect),
            );
          } else {
            setGiaGoiVay(
              parseFloat(goivayDetail[0].HanMucGoiVay) -
                parseFloat(TongTienGiamTruSelect),
            );
          }
        } else {
          setGiaGoiVay(
            parseFloat(goivayDetail[0].HanMucGoiVay) -
              parseFloat(TongTienGiamTruSelect),
          );
        }
      } else {
        setGiaGoiVay(0 - parseFloat(TongTienGiamTruSelect));
      }
    });
  };

  const setModalThuocTinhGiamTru = () => {
    setShowModalThuocTinhGiamTru(!isShowModalThuocTinhGiamTru);
  };

  const getDanhSachThuocTinhGiamTru = (sanphamId) => {
    CamDoApi.getThongTinThuocTinhGiamTru(sanphamId, LoaiTaiSan).then(
      (response) => {
        setListThuocTinhGiamTru(response.data.List);
      },
    );
  };

  const xoaThuocTinhGiamTru = (giamtruId) => () => {
    // var listSelectNew = ListThuocTinhGiamTruSelect.filter(function (item) {
    //   return item.ThuocTinhGiamTruId !== giamtruId
    // })

    var tiengiamtruconglai = 0;
    var thuoctinhSelect = [];
    var tongtiengiamtru = 0;
    ListThuocTinhGiamTruSelect &&
      ListThuocTinhGiamTruSelect.map((item, idx) => {
        if (parseInt(item.ThuocTinhGiamTruId) !== parseInt(giamtruId)) {
          //alert(item.ThuocTinhGiamTruId)
          thuoctinhSelect.push(item);
          tongtiengiamtru += parseFloat(item.TienGiamTru);
        } else {
          tiengiamtruconglai += parseFloat(item.TienGiamTru);
        }
      });

    var giagoivay = parseFloat(GiaGoiVay) + parseFloat(tiengiamtruconglai);
    var giasanpham = parseFloat(GiaSanPham) + parseFloat(tiengiamtruconglai);
    setGiaGoiVay(giagoivay);
    setGiaSanPham(giasanpham);
    setListThuocTinhGiamTruSelect(thuoctinhSelect);
    setTongTienGiamTruSelect(tongtiengiamtru);
  };

  return (
    <Modal
      show={show}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <div
        className={
          "loader loader-default " + (postCamDoLoading ? "is-active" : "")
        }
      ></div>
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
          </span>{" "}
          {IsCopy ? "Sao chép " : ChoVayId > 0 ? "Thay đổi " : "Thêm mới "} hợp
          đồng cầm đồ
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={closeThemMoi()}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <div
        className={
          "loader loader-default " + (postCamDoLoading ? "is-active" : "")
        }
      ></div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body
          style={{ padding: "0px", background: "#F4F5FA !important" }}
        >
          <div className="form tat-toan form-horizontal form-edit thoimoihopdong">
            <div className="form-body">
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse196"
                  className="card-header border-info"
                  data-toggle="collapse"
                  href="#collapse196"
                  aria-expanded="true"
                  aria-controls="collapse196"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thông tin khách vay</h3>
                  </a>
                </div>
                <div
                  id="collapse196"
                  role="tabpanel"
                  aria-labelledby="headingCollapse96"
                  className="card-collapse collapse show"
                >
                  <CustomerForm
                    customerId={CustomerID}
                    currentForm={currentForm}
                    autocompleteData={autocompleteData}
                    getAutocompleteCustomer={getAutocompleteCustomer}
                    userCombo={combo}
                    comboNguonKhachHang={comboNguonKhachHang}
                    customer={customer}
                    getDetailCustomer={getDetailCustomer}
                    errors={errors}
                    IsEditCustomer={IsEditCustomer}
                    checkEditCustomer={checkEditCustomer}
                    setEnableEditCustomer={setEnableEditCustomer}
                    IsCopy={IsCopy}
                    CodeCuaHang={thongTinCuaHang.Code}
                  ></CustomerForm>
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse200"
                  className="card-header mt-1 mt-1"
                  data-toggle="collapse"
                  href="#collapse200"
                  aria-expanded="true"
                  aria-controls="collapse194"
                  style={{ display: useThamDinhTaiSan ? "" : "none" }}
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thẩm định tài sản</h3>
                  </a>
                </div>
                <div
                  id="collapse200"
                  role="tabpanel"
                  aria-labelledby="headingCollapse200"
                  className="card-collapse collapse show"
                  style={{ display: useThamDinhTaiSan ? "" : "none" }}
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div
                        className="col-md-12"
                        style={{
                          padding: "5px",
                          border: "1px",
                          borderStyle: "solid",
                          borderColor: "#CACFE7",
                          position: "initial",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                        }}
                      >
                        <div className="row">
                          <div className="form-mobile-ts">
                            <div
                              className="col-md-2"
                              style={{
                                paddingRight: "0px",
                                borderRight: "1px",
                                borderRightStyle: "solid",
                                borderRightColor: "#CACFE7",
                              }}
                            >
                              <select
                                name="ListHangTheChap[0].LoaiTaiSan"
                                className="form-control input-sm"
                                ref={register}
                                value={LoaiTaiSan}
                                onChange={onChangeLoaiTaiSan}
                                defaultValue={LoaiTaiSan}
                                disabled={IsEditChoVay}
                                style={{ border: "0px", borderRadius: "0" }}
                              >
                                <option key={"comboLoaiTaiSan0"} value="0">
                                  Loại tài sản
                                </option>
                                {ListLoaiTaiSan &&
                                  ListLoaiTaiSan.map((item, idx) => (
                                    <option
                                      key={"comboLoaiTaiSan" + idx}
                                      value={item.value}
                                    >
                                      {item.label}
                                    </option>
                                  ))}
                              </select>
                            </div>
                            <div
                              className="col-md-2"
                              style={{
                                padding: "0px",
                                borderRight: "1px",
                                borderRightStyle: "solid",
                                borderRightColor: "#CACFE7",
                              }}
                            >
                              <select
                                className="form-control input-sm"
                                ref={register}
                                value={HangSanXuat}
                                onChange={onChangeHangSanXuat}
                                defaultValue={HangSanXuat}
                                disabled={IsEditChoVay}
                                style={{ border: "0px", borderRadius: "0" }}
                              >
                                {ListHangSanXuat &&
                                  ListHangSanXuat.map((item, idx) => (
                                    <option
                                      key={"comboHangSanXuat" + idx}
                                      value={item.Id}
                                    >
                                      {item.Value}
                                    </option>
                                  ))}
                              </select>
                            </div>
                            <div
                              className="col-md-2"
                              style={{
                                padding: "0px",
                                borderRight: "1px",
                                borderRightStyle: "solid",
                                borderRightColor: "#CACFE7",
                              }}
                            >
                              <select
                                className="form-control input-sm"
                                ref={register}
                                value={DongSanPham}
                                onChange={onChangeDongSanPham}
                                defaultValue={DongSanPham}
                                style={{ border: "0px", borderRadius: "0" }}
                                disabled={IsEditChoVay}
                              >
                                {ListDongSanPham &&
                                  ListDongSanPham.map((item, idx) => (
                                    <option
                                      key={"comboDongSanPham" + idx}
                                      value={item.Id}
                                    >
                                      {item.Value}
                                    </option>
                                  ))}
                              </select>
                            </div>
                            <div
                              className="col-md-1"
                              style={{
                                padding: "0px",
                                borderRight: "1px",
                                borderRightStyle: "solid",
                                borderRightColor: "#CACFE7",
                              }}
                            >
                              <select
                                className="form-control input-sm"
                                ref={register}
                                value={NamSanXuat}
                                onChange={onChangeNamSanXuat}
                                defaultValue={NamSanXuat}
                                disabled={IsEditChoVay}
                                style={{ border: "0px", borderRadius: "0" }}
                              >
                                {ListNamSanXuat &&
                                  ListNamSanXuat.map((item, idx) => (
                                    <option
                                      key={"comboNamSanXuat" + idx}
                                      value={item.Id}
                                    >
                                      {item.Value}
                                    </option>
                                  ))}
                              </select>
                            </div>
                            <div
                              className="col-md-5"
                              style={{ paddingLeft: "0px" }}
                            >
                              <select
                                className="form-control input-sm"
                                ref={register}
                                value={SanPham}
                                onChange={onChangeSanPham}
                                defaultValue={SanPham}
                                disabled={IsEditChoVay}
                                style={{
                                  border: "0px",
                                  borderRadius: "0",
                                  textTransform: "unset",
                                }}
                              >
                                {ListSanPham &&
                                  ListSanPham.map((item, idx) => (
                                    <option
                                      key={"comboSanPham" + idx}
                                      value={item.Id}
                                    >
                                      {item.Value}
                                    </option>
                                  ))}
                                {ListSanPham == undefined && (
                                  <option key="comboSanPham0" value="0">
                                    Tên sản phẩm
                                  </option>
                                )}
                              </select>
                            </div>

                            {/* <a
                                href={() => false}
                                onClick={() => showModalLoaiTaiSan(true)}
                              >
                                <span className="ad-ts">
                                  <i className="mdi mdi-plus"></i>
                                </span>
                              </a> */}
                          </div>
                        </div>
                      </div>

                      {SanPham != undefined && SanPham > 0 && (
                        <div
                          className="col-md-12"
                          style={{
                            marginTop: "10px",
                            color: "#000",
                            borderRadius: "10px",
                            border: "1px",
                            borderStyle: "solid",
                            borderColor: "#CACFE7",
                          }}
                        >
                          <div
                            className="row"
                            style={{
                              minHeight: "30px",
                              padding: "10px 0px 10px 0px",
                            }}
                          >
                            <div
                              className="col-md-6 color7-bold"
                              style={{ marginBottom: "10px" }}
                            >
                              Thuộc tính giảm trừ
                            </div>
                            <div
                              className="col-md-6 "
                              style={{
                                textAlign: "right",
                                marginBottom: "10px",
                              }}
                            >
                              {(ListThuocTinhGiamTruSelect == undefined ||
                                ListThuocTinhGiamTruSelect.length == 0 ||
                                IsEditChoVay) && (
                                <a style={{ color: "#00B69B" }}>
                                  <i class="mdi mdi-pencil color7"></i> Sửa
                                  thuộc tính
                                </a>
                              )}
                              {ListThuocTinhGiamTruSelect &&
                                ListThuocTinhGiamTruSelect.length > 0 &&
                                !IsEditChoVay && (
                                  <a
                                    style={{ color: "#00B69B" }}
                                    onClick={setModalThuocTinhGiamTru}
                                  >
                                    <i class="mdi mdi-pencil"></i> Sửa thuộc
                                    tính
                                  </a>
                                )}
                            </div>
                            <div
                              class="col-md-12 color-xanh-bold"
                              style={{ marginBottom: "10px" }}
                            >
                              {ListThuocTinhGiamTruSelect &&
                                ListThuocTinhGiamTruSelect.length > 0 &&
                                ListThuocTinhGiamTruSelect.map((item, idx) => (
                                  <div
                                    style={{
                                      border: "1px",
                                      borderStyle: "solid",
                                      borderColor: "#DDDDDD",
                                      margin: "3px",
                                      padding: "8px",
                                      minWidth: "100px",
                                      float: "left",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    {item.TenThuocTinh}
                                    {!IsEditChoVay && (
                                      <a
                                        onClick={xoaThuocTinhGiamTru(
                                          item.ThuocTinhGiamTruId,
                                        )}
                                        style={{
                                          float: "right",
                                          marginLeft: "5px",
                                        }}
                                      >
                                        <i
                                          className="mdi mdi-close-circle color-do-bold"
                                          style={{
                                            fontSize: "15px",
                                            paddingTop: "-5px",
                                          }}
                                        ></i>
                                      </a>
                                    )}
                                  </div>
                                ))}

                              {ListThuocTinhGiamTruSelect == undefined ||
                                (ListThuocTinhGiamTruSelect.length == 0 && (
                                  <a
                                    style={{ color: "#00B69B" }}
                                    onClick={setModalThuocTinhGiamTru}
                                  >
                                    Chọn thuộc tính
                                  </a>
                                ))}
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="col-md-12">
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div
                            className="col-md-3"
                            style={{ paddingLeft: "0px" }}
                          >
                            <select
                              className="form-control input-sm"
                              ref={register}
                              value={GoiVay}
                              onChange={onChangeGoiVay}
                              defaultValue={GoiVay}
                              disabled={IsEditChoVay}
                            >
                              {ListGoiVay &&
                                ListGoiVay.map((item, idx) => (
                                  <option
                                    key={"comboGoiVay" + idx}
                                    value={item.Id}
                                  >
                                    {item.Value}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div
                            className="col-md-9"
                            style={{
                              backgroundColor: "#E7F9E9",
                              color: "#000",
                              borderRadius: "10px",
                              border: "1px",
                              borderStyle: "solid",
                              borderColor: "#CACFE7",
                              display: "flex",
                            }}
                          >
                            <div
                              className="row"
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div className="col-md-6">
                                Giá sau giảm trừ:{" "}
                                <b>{formatNumber(GiaSanPham)}</b>
                              </div>
                              <div className="col-md-6">
                                Giá cho vay tối đa:{" "}
                                <b className="color-do-bold">
                                  {formatNumber(GiaGoiVay)}
                                </b>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div>
                  <div
                    id="headingCollapse194"
                    className="card-header mt-1"
                    data-toggle="collapse"
                    href="#collapse194"
                    aria-expanded="true"
                    aria-controls="collapse194"
                    display={useThamDinhTaiSan == false ? "none" : ""}
                  >
                    <a
                      className="card-title lead info collapsed"
                      href={() => false}
                    >
                      <h3>Thông tin cho vay</h3>
                    </a>
                  </div>
                  <div
                    id="collapse194"
                    role="tabpanel"
                    aria-labelledby="headingCollapse94"
                    className="card-collapse collapse show"
                  >
                    <div className="card-content">
                      <div className="card-body">
                        <div className="row">
                          <input
                            type="hidden"
                            name="ChoVayId"
                            value={ChoVayId}
                            ref={register}
                          ></input>
                          <div className="col-md-12 col-lg-12">
                            {(choVayEdit.ChoVayId === 0 ||
                              (IsDuNoGiamDan && choVayEdit.ChoVayId > 0)) && (
                              <>
                                <div className="col-md-6 ">
                                  <input
                                    id="chkDuNoGiamDan"
                                    type="checkbox"
                                    onChange={onChangDuNoGiamDan}
                                    checked={isDuNoGiamDan}
                                    disabled={ChoVayId}
                                  ></input>
                                  <label
                                    for="chkDuNoGiamDan"
                                    className="color7-bold"
                                  >
                                    &nbsp;Sử dụng dư nợ giảm dần
                                  </label>
                                </div>
                              </>
                            )}

                            <div
                              className="row thongtinchovay-v2"
                              style={{
                                display: useThamDinhTaiSan ? "none" : "",
                              }}
                            >
                              <div className="col-md-4">
                                <ControllerTextInputTwoRow
                                  labelClass="col-md-4 label-control"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-8"
                                  wrapperClass="form-group row"
                                  labelText="Tên tài sản"
                                  starRed="*"
                                  inputProps={{
                                    rules: {
                                      required: useThamDinhTaiSan
                                        ? false
                                        : "Hãy nhập tên tài sản",
                                    },
                                    name: "ListHangTheChap[0].TenTaiSan",
                                    onChange: setAttTaiSan("TenTaiSan"),
                                    value: TenTaiSan,
                                    control: control,
                                    disabled: IsEditChoVay,
                                  }}
                                  error={
                                    errors.ListHangTheChap &&
                                    errors.ListHangTheChap[0] &&
                                    errors.ListHangTheChap[0].TenTaiSan
                                  }
                                ></ControllerTextInputTwoRow>
                              </div>
                              <div className="col-md-4">
                                <label className="label-control color7-bold">
                                  Loại tài sản{" "}
                                  <span className="canh-bao-red">*</span>
                                </label>
                                <select
                                  name="ListHangTheChap[0].LoaiTaiSan"
                                  className="form-control input-sm"
                                  ref={register}
                                  value={LoaiTaiSan}
                                  onChange={onChangeLoaiTaiSan}
                                  defaultValue={LoaiTaiSan}
                                  disabled={IsEditChoVay}
                                >
                                  {ListLoaiTaiSan &&
                                    ListLoaiTaiSan.map((item, idx) => (
                                      <option
                                        key={"comboLoaiTaiSan" + idx}
                                        value={item.value}
                                      >
                                        {item.label}
                                      </option>
                                    ))}
                                </select>
                              </div>{" "}
                              <div className="col-md-4">
                                <label className="label-control color7-bold">
                                  {" "}
                                </label>
                                <br />
                                <a
                                  href={() => false}
                                  onClick={() => showModalLoaiTaiSan(true)}
                                >
                                  <span className="ad-ts">
                                    <i className="mdi mdi-plus"></i>
                                  </span>
                                </a>
                              </div>
                            </div>

                            <div className="row thongtinchovay-v2">
                              <div className="col-md-4">
                                <label className="label-control color7-bold">
                                  Ngày vay{" "}
                                  <span className="canh-bao-red">*</span>
                                </label>
                                <br />
                                <DateTimePicker
                                  onChange={onChangeNgayVay}
                                  value={NgayVay}
                                  name="NgayVay"
                                  customInputRef={register}
                                  customInput={
                                    <input
                                      name="NgayVay"
                                      ref={register}
                                    ></input>
                                  }
                                  readOnly={IsEditChoVay || !chonngaygiaodich}
                                ></DateTimePicker>
                              </div>
                              {isDuNoGiamDan == true && (
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    {" "}
                                    Ngày bắt đầu tính lãi{" "}
                                    <span className="canh-bao-red">*</span>
                                  </label>
                                  <br />
                                  <div>
                                    <DateTimePicker
                                      onChange={onChangeNgayThanhToan}
                                      value={NgayThanhToan}
                                      customInputRef={register}
                                      readOnly={IsEditChoVay}
                                      name="NgayThanhToan"
                                      customInput={
                                        <input
                                          name="NgayThanhToan"
                                          ref={register}
                                        ></input>
                                      }
                                    ></DateTimePicker>
                                  </div>
                                </div>
                              )}
                              {!IsCopy && (
                                <div className="col-md-4">
                                  <TextInputTwoRow
                                    labelClass="col-md-2 label-control"
                                    inputClass="form-control input-sm"
                                    inputWrapClass="col-md-4"
                                    wrapperClass="form-group row"
                                    labelText="Mã hợp đồng"
                                    placeholder="Mã hợp đồng"
                                    inputProps={{
                                      ref: register,
                                      name: "Code",
                                      readOnly: ChoVayId,
                                    }}
                                  ></TextInputTwoRow>
                                </div>
                              )}
                              <div className="col-md-12"></div>
                              <div className="col-md-4">
                                <NumberInput
                                  labelClass="label-control"
                                  inputClass="form-control input-sm"
                                  inputWrapClass="col-md-8"
                                  wrapperClass="row"
                                  labelText="Tổng tiền vay"
                                  starRed="*"
                                  placeholder="10,000,000"
                                  inputProps={{
                                    name: "Sotienvay",
                                    value: Sotienvay,
                                    onChange:
                                      onChangeAttNumberChoVay("Sotienvay"),
                                    rules: {
                                      required: "Hãy nhập số tiền vay",
                                    },
                                    control: control,
                                    readOnly: IsEditChoVay,
                                  }}
                                  error={errors.Sotienvay}
                                ></NumberInput>
                                <div
                                  style={{
                                    display: useThamDinhTaiSan ? "" : "none",
                                  }}
                                  className="col-md-12 color-cam"
                                >
                                  <i style={{ fontSize: "13px" }}>
                                    (Tổng tiền vay không được quá{" "}
                                    {formatNumber(GiaGoiVay)})
                                  </i>
                                </div>{" "}
                              </div>
                              {isDuNoGiamDan == true && (
                                <>
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      Thời gian vay
                                      <span className="canh-bao-red">*</span>
                                    </label>
                                    <br />
                                    <NumberField
                                      className="form-control input-sm"
                                      name={"BocTrongVong"}
                                      value={BocTrongVong}
                                      onChange={onChangeAttNumberChoVay(
                                        "BocTrongVong",
                                      )}
                                      placeholder={"50"}
                                      readOnly={IsEditChoVay}
                                      inputRef={register({
                                        required: "Hãy nhập thời gian vay",
                                      })}
                                    ></NumberField>
                                    {errors.BocTrongVong && (
                                      <span className="canh-bao-red">
                                        {errors.BocTrongVong.message}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      {isDuNoGiamDan
                                        ? "Chi phí vay/tháng(%)"
                                        : "Chi phí vay"}
                                      <span className="canh-bao-red">*</span>
                                    </label>
                                    <br />
                                    <Controller
                                      name="ChiPhiVay"
                                      rules={{
                                        required: "Hãy nhập số",
                                      }}
                                      control={control}
                                      readOnly={IsEditChoVay}
                                      defaultValue={ChiPhiVay}
                                      className="form-control input-sm"
                                      as={NumberFormat}
                                      placeholder={"%"}
                                    />
                                  </div>
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      Phí thanh toán sớm
                                    </label>
                                    <br />
                                    <Controller
                                      name="PhiThanhToanSom"
                                      control={control}
                                      defaultValue={PhiThanhToanSom}
                                      className="form-control input-sm"
                                      as={NumberFormat}
                                      readOnly={IsEditChoVay}
                                      placeholder={"%"}
                                    />
                                  </div>
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      Phí bảo hiểm
                                    </label>
                                    <br />
                                    <Controller
                                      name="PhiBaoHiem"
                                      control={control}
                                      readOnly={IsEditChoVay}
                                      defaultValue={PhiBaoHiem}
                                      className="form-control input-sm"
                                      as={NumberFormat}
                                      placeholder={"%"}
                                    />
                                  </div>
                                </>
                              )}
                              {isDuNoGiamDan == true && (
                                <>
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      Thời gian vay
                                      <span className="canh-bao-red">*</span>
                                    </label>
                                    <br />
                                    <NumberField
                                      className="form-control input-sm"
                                      name={"BocTrongVong"}
                                      value={BocTrongVong}
                                      onChange={onChangeAttNumberChoVay(
                                        "BocTrongVong",
                                      )}
                                      placeholder={"50"}
                                      readOnly={IsEditChoVay}
                                      inputRef={register({
                                        required: "Hãy nhập thời gian vay",
                                      })}
                                    ></NumberField>
                                    {errors.BocTrongVong && (
                                      <span className="canh-bao-red">
                                        {errors.BocTrongVong.message}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      {isDuNoGiamDan
                                        ? "Chi phí vay/tháng(%)"
                                        : "Chi phí vay"}
                                      <span className="canh-bao-red">*</span>
                                    </label>
                                    <br />
                                    <Controller
                                      name="ChiPhiVay"
                                      rules={{
                                        required: "Hãy nhập số",
                                      }}
                                      control={control}
                                      readOnly={IsEditChoVay}
                                      defaultValue={ChiPhiVay}
                                      className="form-control input-sm"
                                      as={NumberFormat}
                                      placeholder={"%"}
                                    />
                                  </div>
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      Phí thanh toán sớm
                                    </label>
                                    <br />
                                    <Controller
                                      name="PhiThanhToanSom"
                                      control={control}
                                      defaultValue={PhiThanhToanSom}
                                      className="form-control input-sm"
                                      as={NumberFormat}
                                      readOnly={IsEditChoVay}
                                      placeholder={"%"}
                                    />
                                  </div>
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      Phí bảo hiểm
                                    </label>
                                    <br />
                                    <Controller
                                      name="PhiBaoHiem"
                                      control={control}
                                      readOnly={IsEditChoVay}
                                      defaultValue={PhiBaoHiem}
                                      className="form-control input-sm"
                                      as={NumberFormat}
                                      placeholder={"%"}
                                    />
                                  </div>
                                </>
                              )}

                              {(isDuNoGiamDan == undefined ||
                                isDuNoGiamDan == false) && (
                                <>
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      Kỳ đóng lãi{" "}
                                      <span className="canh-bao-red">
                                        *
                                        <PopoversBootrap
                                          contentText="10 ngày/tháng đóng lãi 1 lần thì điền số 10"
                                          titleText=""
                                          trigger={["hover", "focus"]}
                                          placement={"top"}
                                        >
                                          <i className="la la-question-circle tool-comment"></i>
                                        </PopoversBootrap>
                                      </span>
                                    </label>
                                    <br />
                                    <div class="row">
                                      <div
                                        className="col-md-7 "
                                        style={{ paddingRight: "0px" }}
                                      >
                                        <Controller
                                          name="CountTypePaid"
                                          rules={{
                                            required: "Hãy nhập kỳ đóng lãi",
                                          }}
                                          control={control}
                                          defaultValue={CountTypePaid}
                                          className="form-control left input-sm"
                                          as={NumberFormat}
                                          // placeholder="%"
                                          disabled={IsEditChoVay}
                                        />
                                        <span className="canh-bao-red">
                                          {errors.CountTypePaid &&
                                            errors.CountTypePaid.message}
                                        </span>
                                      </div>
                                      <div
                                        className="col-md-5"
                                        style={{ paddingLeft: "0px" }}
                                      >
                                        <select
                                          name="TypePaid"
                                          ref={register}
                                          className="form-control right  input-sm select-v2"
                                          onChange={onChangeTypePaid()}
                                          value={TypePaid}
                                          defaultValue={TypePaid}
                                          disabled={IsEditChoVay}
                                        >
                                          {bindTypePaid(objConfigSysLoaiTS)}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-12"></div>
                                  <div className="col-md-4">
                                    <label className="label-control color7-bold">
                                      Lãi suất{" "}
                                      <span className="canh-bao-red">*</span>
                                    </label>
                                    <br />
                                    <div class="row">
                                      <div
                                        className="col-md-7"
                                        style={{ paddingRight: "0px" }}
                                      >
                                        <Controller
                                          name="LaiSuat"
                                          rules={{
                                            required: "Hãy nhập lãi suất",
                                          }}
                                          control={control}
                                          readOnly={IsEditChoVay}
                                          defaultValue={LaiSuat}
                                          className="form-control left input-sm "
                                          // onChange, onBlur, value, name, ref inejcted to the component
                                          as={NumberFormat}
                                          placeholder={
                                            parseFloat(TypePaid) === 3
                                              ? "%"
                                              : choVayConst
                                                  .KieuLaiSuatPlaceholder[
                                                  KieuLaiSuat
                                                ]
                                          }
                                        />
                                        <span className="canh-bao-red">
                                          {errors.LaiSuat &&
                                            errors.LaiSuat.message}
                                        </span>
                                      </div>
                                      <div
                                        className="col-md-5"
                                        style={{ paddingLeft: "0px" }}
                                      >
                                        {parseFloat(TypePaid) !== 3 && (
                                          <select
                                            name="KieuLaiSuat"
                                            ref={register}
                                            className="form-control  right input-sm select-v2"
                                            onChange={onChangeAttTextChoVay(
                                              "KieuLaiSuat",
                                            )}
                                            value={KieuLaiSuat}
                                            defaultValue={KieuLaiSuat}
                                            disabled={IsEditChoVay}
                                          >
                                            {bindKieuLaiSuat(
                                              objConfigSysLoaiTS,
                                              TypePaid,
                                            )}
                                          </select>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-12"></div>
                                  {OptionTinhLai === ConfigConst.ShowDate ? (
                                    <div className="col-md-4">
                                      <label className="label-control color7-bold">
                                        Ngày trả{" "}
                                        <span className="canh-bao-red">*</span>
                                      </label>
                                      <br />
                                      <DateTimePicker
                                        onChange={onChangeNgayTra}
                                        value={NgayTra}
                                        name="NgayTra"
                                        customInputRef={register({
                                          required: "Hãy nhập ngày trả",
                                        })}
                                        customInput={
                                          <input
                                            name="NgayTra"
                                            ref={register}
                                          ></input>
                                        }
                                        readOnly={IsEditChoVay}
                                      ></DateTimePicker>
                                      {/* <div className="input-group-append">
                                      <span className="input-group-text">
                                        <i className="mdi mdi-calendar"></i>
                                      </span>
                                    </div> */}
                                    </div>
                                  ) : IsTongSoNgay ? (
                                    <div className="col-md-4">
                                      <NumberInput
                                        labelClass="col-md-2 label-control"
                                        inputClass="form-control input-sm"
                                        inputWrapClass="col-md-4"
                                        wrapperClass="form-group row"
                                        labelText="Số ngày trả lãi"
                                        starRed="*"
                                        placeholder="12"
                                        inputProps={{
                                          name: "TongNgayVay",
                                          value: TongNgayVay,
                                          onChange:
                                            onChangeAttNumberChoVay(
                                              "TongNgayVay",
                                            ),
                                          rules: {
                                            required:
                                              "Hãy nhập tổng số ngày trả",
                                          },
                                          control: control,
                                          disabled: IsEditChoVay,
                                        }}
                                        error={errors.TongNgayVay}
                                      ></NumberInput>
                                    </div>
                                  ) : (
                                    <div className="col-md-4">
                                      <NumberInput
                                        labelClass="col-md-2 label-control"
                                        inputClass="form-control input-sm"
                                        inputWrapClass="col-md-4"
                                        wrapperClass="form-group row"
                                        labelText="Số lần trả"
                                        starRed="*"
                                        toolTip
                                        textToolTip="Số kỳ trả 10 kỳ điền số 10"
                                        placeholder="12"
                                        inputProps={{
                                          name: "SoLanTra",
                                          value: SoLanTra,
                                          onChange:
                                            onChangeAttNumberChoVay("SoLanTra"),
                                          rules: {
                                            required: "Hãy nhập số lần trả",
                                          },
                                          control: control,
                                          readOnly: IsEditChoVay,
                                        }}
                                        error={errors.SoLanTra}
                                      ></NumberInput>
                                    </div>
                                  )}

                                  <div className="col-md-12"></div>
                                  <div
                                    className={
                                      "col-md-4" +
                                      (objConfigSysLoaiTS._allBeforeAfterTinChapCamDo
                                        ? ""
                                        : " hidden")
                                    }
                                  >
                                    <label className="label-control color7-bold">
                                      Kiểu thu lãi{" "}
                                      <span className="canh-bao-red">*</span>
                                    </label>
                                    <br />
                                    <select
                                      name="BeforeAfter"
                                      className="form-control input-sm select-v2"
                                      ref={register}
                                      value={BeforeAfter}
                                      onChange={onChangeAttTextChoVay(
                                        "BeforeAfter",
                                      )}
                                      disabled={IsEditChoVay}
                                    >
                                      <option value="1">Sau</option>
                                      <option value="2">Trước</option>
                                    </select>
                                  </div>
                                  <div className="col-md-12"></div>
                                  {IsGiaHanTuDong && (
                                    <div className="col-md-4">
                                      <NumberInput
                                        labelClass="label-control color7-bold"
                                        inputClass="form-control input-sm"
                                        inputWrapClass="col-md-4"
                                        wrapperClass="form-group row"
                                        labelText="Thêm ngày quá hạn"
                                        placeholder="1"
                                        inputProps={{
                                          name: "SoNgayGiaHanTuDong",
                                          value: SoNgayGiaHan,
                                          onChange:
                                            onChangeAttNumberChoVay(
                                              "SoNgayGiaHan",
                                            ),
                                          control: control,
                                          disabled: IsEditChoVay,
                                        }}
                                      ></NumberInput>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                            {isDuDungPhiPhatDongLaiTatToan &&
                              isDuNoGiamDan === false && (
                                <>
                                  <div className="row">
                                    <div className="col-md-4">
                                      <NumberInput
                                        labelClass="col-md-6 label-control"
                                        inputClass="form-control input-sm"
                                        inputWrapClass="col-md-6"
                                        labelText="Phạt chậm đóng lãi"
                                        wrapperClass="form-group row"
                                        inputProps={{
                                          name: "PhiPhatTraLai",
                                          value: PhiPhatTraLai,
                                          onChange:
                                            onChangeAttNumberChoVay(
                                              "PhiPhatTraLai",
                                            ),
                                          control: control,
                                          readOnly: IsEditChoVay,
                                        }}
                                      ></NumberInput>
                                    </div>
                                    <div className="col-md-4 radio-button-nhap-tien">
                                      <label className="custom-radio">
                                        <input
                                          type="radio"
                                          name="LoaiPhiPhatTraLai"
                                          onChange={onChangeLoaiPhiPhatTraLai(
                                            1,
                                          )}
                                          checked={
                                            intLoaiPhiPhatTraLai === 1
                                              ? true
                                              : false
                                          }
                                          disabled={IsEditChoVay}
                                        />{" "}
                                        <span className="radio-mark"></span>
                                        Nhập tiền
                                      </label>
                                      <label className="custom-radio radio-button-nhap-phan-tram">
                                        <input
                                          type="radio"
                                          name="LoaiPhiPhatTraLai"
                                          onChange={onChangeLoaiPhiPhatTraLai(
                                            2,
                                          )}
                                          checked={
                                            intLoaiPhiPhatTraLai === 2
                                              ? true
                                              : false
                                          }
                                          disabled={IsEditChoVay}
                                        />{" "}
                                        <span className="radio-mark"></span>
                                        Nhập %
                                      </label>
                                    </div>
                                  </div>
                                </>
                              )}
                            {props.isSuDungTatToanSom && (
                              <>
                                <div className="row">
                                  <div className="col-md-4">
                                    <NumberInput
                                      labelClass="col-md-6 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-6"
                                      labelText="Phạt tất toán sớm"
                                      wrapperClass="form-group row"
                                      inputProps={{
                                        name: "PhiPhatTatToan",
                                        value: PhiPhatTatToan,
                                        onChange:
                                          onChangeAttNumberChoVay(
                                            "PhiPhatTatToan",
                                          ),
                                        control: control,
                                        readOnly: IsEditChoVay,
                                      }}
                                    ></NumberInput>
                                  </div>
                                  <div className="col-md-4 radio-button-nhap-tien">
                                    <label className="custom-radio">
                                      <input
                                        type="radio"
                                        name="LoaiPhiPhatTatToan"
                                        onChange={onChangeLoaiPhiPhatTatToan(1)}
                                        checked={
                                          intLoaiPhiPhatTatToan === 1
                                            ? true
                                            : false
                                        }
                                        disabled={IsEditChoVay}
                                      />{" "}
                                      <span className="radio-mark"></span>
                                      Nhập tiền
                                    </label>
                                    <label className="custom-radio radio-button-nhap-phan-tram">
                                      <input
                                        type="radio"
                                        name="LoaiPhiPhatTatToan"
                                        onChange={onChangeLoaiPhiPhatTatToan(2)}
                                        checked={
                                          intLoaiPhiPhatTatToan === 2
                                            ? true
                                            : false
                                        }
                                        disabled={IsEditChoVay}
                                      />{" "}
                                      <span className="radio-mark"></span>
                                      Nhập %
                                    </label>
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="row">
                              {props.isSuDungCongTacVienNhanVien && (
                                <>
                                  <div className="col-md-12"></div>
                                  <div className="col-md-4">
                                    <TextInputTwoRow
                                      labelClass="col-md-2 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-4"
                                      wrapperClass="form-group row"
                                      labelText="Mã nhân viên"
                                      placeholder="Mã nhân viên"
                                      inputProps={{
                                        name: "MaNhanVien",
                                        onChange:
                                          onChangeAttTextChoVay("MaNhanVien"),
                                        value: MaNhanVien,
                                      }}
                                    ></TextInputTwoRow>
                                  </div>
                                </>
                              )}
                              <div className="col-md-12">
                                <label className="label-control color7-bold">
                                  Ghi chú
                                </label>
                                <textarea
                                  rows="1"
                                  style={{ minHeight: "80px" }}
                                  className="form-control input-sm"
                                  name="Note"
                                  placeholder=""
                                  value={Note}
                                  onChange={onChangeAttTextChoVay("Note")}
                                  ref={register}
                                  disabled={IsEditChoVay}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse19412"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse19412"
                  aria-expanded="false"
                  aria-controls="collapse194"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Các loại phí</h3>
                  </a>
                </div>
                <div
                  id="collapse19412"
                  role="tabpanel"
                  aria-labelledby="headingCollapse9412"
                  className="card-collapse collapse"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12 col-lg-12">
                          {objListPhiKhac &&
                            objListPhiKhac.map((item, idx) => (
                              <div key={"phiKhac" + idx}>
                                <div className="row">
                                  <div className="col-md-6">
                                    <NumberInput
                                      labelClass="col-md-6 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-6"
                                      wrapperClass="form-group row"
                                      labelText={item.TenPhiKhac}
                                      inputProps={{
                                        name: "ListPhiKhac[" + idx + "].GiaTri",
                                        value: objListPhiKhac[idx].GiaTri,
                                        onChange: onChangePhiKhac(idx),
                                        control: control,
                                        readOnly: IsEditChoVay,
                                      }}
                                    ></NumberInput>
                                  </div>
                                  <div className="col-md-6">
                                    {item.LoaiPhiKhac == 1 ? (
                                      <>
                                        &nbsp;
                                        <br />
                                        <div
                                          className="col-md-12"
                                          style={{ paddingTop: "20px" }}
                                        >
                                          <label className="custom-radio">
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="1"
                                              checked={true}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập tiền
                                          </label>
                                          <label
                                            className="custom-radio"
                                            style={{ paddingLeft: "10px" }}
                                          >
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="2"
                                              checked={false}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập %
                                          </label>
                                        </div>
                                      </>
                                    ) : item.LoaiPhiKhac == 2 ? (
                                      <>
                                        &nbsp;
                                        <br />
                                        <div
                                          className="col-md-12"
                                          style={{ paddingTop: "20px" }}
                                        >
                                          <label className="custom-radio">
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="1"
                                              checked={false}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập %
                                          </label>
                                          <label
                                            className="custom-radio"
                                            style={{ paddingLeft: "10px" }}
                                          >
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhac"
                                              }
                                              value="2"
                                              checked={true}
                                              disabled={true}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập %
                                          </label>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        &nbsp;
                                        <br />
                                        <div
                                          className="col-md-12"
                                          style={{ paddingTop: "20px" }}
                                        >
                                          <label className="custom-radio">
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhacChon"
                                              }
                                              value="1"
                                              checked={
                                                objListPhiKhac[idx]
                                                  .LoaiPhiKhacChon === 1
                                                  ? true
                                                  : false
                                              }
                                              ref={register}
                                              disabled={IsEditChoVay}
                                              onChange={onChangeLoaiPhiKhac(
                                                idx,
                                                1,
                                              )}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập tiền
                                          </label>
                                          <label
                                            className="custom-radio"
                                            style={{ paddingLeft: "10px" }}
                                          >
                                            <input
                                              type="radio"
                                              name={
                                                "ListPhiKhac[" +
                                                idx +
                                                "].LoaiPhiKhacChon"
                                              }
                                              value="2"
                                              checked={
                                                objListPhiKhac[idx]
                                                  .LoaiPhiKhacChon === 2
                                                  ? true
                                                  : false
                                              }
                                              ref={register}
                                              disabled={IsEditChoVay}
                                              onChange={onChangeLoaiPhiKhac(
                                                idx,
                                                2,
                                              )}
                                            />{" "}
                                            <span className="radio-mark"></span>
                                            Nhập %
                                          </label>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <input
                                  type="hidden"
                                  name={
                                    "ListPhiKhac[" + idx + "].ConfigPhiKhacId"
                                  }
                                  value={item.ConfigPhiKhacId}
                                  ref={register}
                                />
                                <input
                                  type="hidden"
                                  name={"ListPhiKhac[" + idx + "].LoaiPhiKhac"}
                                  value={item.LoaiPhiKhac}
                                  ref={register}
                                />
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {objListPhiKhacHangKy != undefined &&
                    objListPhiKhacHangKy.length > 0 && (
                      <>
                        <div
                          id="headingCollapse194121"
                          className="card-header  mt-1"
                          data-toggle="collapse"
                          href="#collapse194121"
                          aria-expanded="false"
                          aria-controls="collapse1941"
                        >
                          <a
                            className="card-title lead info collapsed"
                            href={() => false}
                          >
                            <h3>Các loại phí hàng kỳ</h3>
                          </a>
                        </div>
                        <div
                          id="collapse194121"
                          role="tabpanel"
                          aria-labelledby="headingCollapse194121"
                          className="card-collapse collapse"
                        >
                          <div className="card-content">
                            <div className="card-body">
                              <div className="row">
                                <div className="col-md-12 col-lg-12">
                                  {objListPhiKhacHangKy &&
                                    objListPhiKhacHangKy.map((item, idx) => (
                                      <div key={"phiKhacHangKy" + idx}>
                                        <div className="row">
                                          <div className="col-md-6">
                                            <NumberInput
                                              labelClass="col-md-6 label-control"
                                              inputClass="form-control input-sm"
                                              inputWrapClass="col-md-6"
                                              wrapperClass="form-group row"
                                              labelText={item.TenPhiKhacHangKy}
                                              inputProps={{
                                                name:
                                                  "ListPhiKhacHangKy[" +
                                                  idx +
                                                  "].GiaTri",
                                                value:
                                                  objListPhiKhacHangKy[idx]
                                                    .GiaTri,
                                                onChange:
                                                  onChangePhiKhacHangKy(idx),
                                                control: control,
                                              }}
                                            ></NumberInput>
                                          </div>
                                          <div className="col-md-6">
                                            {item.LoaiPhiKhacHangKy == 1 ? (
                                              <>
                                                &nbsp;
                                                <br />
                                                <div
                                                  className="col-md-12"
                                                  style={{ paddingTop: "20px" }}
                                                >
                                                  <label className="custom-radio">
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="1"
                                                      checked={true}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập tiền
                                                  </label>

                                                  <label
                                                    className="custom-radio"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="2"
                                                      checked={false}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập %
                                                  </label>
                                                </div>
                                              </>
                                            ) : item.LoaiPhiKhacHangKy == 2 ? (
                                              <>
                                                &nbsp;
                                                <br />
                                                <div
                                                  className="col-md-12"
                                                  style={{ paddingTop: "20px" }}
                                                >
                                                  <label className="custom-radio">
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="1"
                                                      checked={false}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập tiền
                                                  </label>
                                                  <label
                                                    className="custom-radio"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKy"
                                                      }
                                                      value="2"
                                                      checked={true}
                                                      disabled={true}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập %
                                                  </label>
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                &nbsp;
                                                <br />
                                                <div
                                                  className="col-md-12"
                                                  style={{ paddingTop: "20px" }}
                                                >
                                                  <label className="custom-radio">
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKyChon"
                                                      }
                                                      value="1"
                                                      checked={
                                                        objListPhiKhacHangKy[
                                                          idx
                                                        ]
                                                          .LoaiPhiKhacHangKyChon ===
                                                        1
                                                          ? true
                                                          : false
                                                      }
                                                      ref={register}
                                                      disabled={IsEditChoVay}
                                                      onChange={onChangeLoaiPhiKhacHangKy(
                                                        idx,
                                                        1,
                                                      )}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập tiền
                                                  </label>

                                                  <label
                                                    className="custom-radio"
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      type="radio"
                                                      name={
                                                        "ListPhiKhacHangKy[" +
                                                        idx +
                                                        "].LoaiPhiKhacHangKyChon"
                                                      }
                                                      value="2"
                                                      checked={
                                                        objListPhiKhacHangKy[
                                                          idx
                                                        ]
                                                          .LoaiPhiKhacHangKyChon ===
                                                        2
                                                          ? true
                                                          : false
                                                      }
                                                      ref={register}
                                                      disabled={IsEditChoVay}
                                                      onChange={onChangeLoaiPhiKhacHangKy(
                                                        idx,
                                                        2,
                                                      )}
                                                    />
                                                    <span className="radio-mark"></span>
                                                    Nhập %
                                                  </label>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                        <input
                                          type="hidden"
                                          name={
                                            "ListPhiKhacHangKy[" +
                                            idx +
                                            "].ConfigPhiKhacHangKyId"
                                          }
                                          value={item.ConfigPhiKhacHangKyId}
                                          ref={register}
                                        />
                                        <input
                                          type="hidden"
                                          name={
                                            "ListPhiKhacHangKy[" +
                                            idx +
                                            "].LoaiPhiKhacHangKy"
                                          }
                                          value={item.LoaiPhiKhacHangKy}
                                          ref={register}
                                        />
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse191"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse191"
                  aria-expanded="false"
                  aria-controls="collapse191"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thông tin tài sản thế chấp</h3>
                  </a>
                </div>
                <div
                  id="collapse191"
                  role="tabpanel"
                  aria-labelledby="headingCollapse191"
                  className="card-collapse collapse"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          {/* <input
                            type="hidden"
                            name="ListHangTheChap[0].LoaiTaiSan"
                            value={LoaiTaiSan}
                            ref={register}
                          ></input> */}
                          <input
                            type="hidden"
                            name="ListHangTheChap[0].CategoryId"
                            value={CategoryId}
                            ref={register}
                          ></input>
                          <div className="row">
                            {ThuocTinhTaiSan &&
                              ThuocTinhTaiSan.map((item, index) => (
                                <div
                                  className="col-md-3"
                                  key={"Thuoctinhts1" + index}
                                >
                                  <TextInputOnRow
                                    labelClass="label-control color7-bold"
                                    inputClass="form-control input-sm"
                                    wrapperClass="form-group"
                                    labelText={item.TenThuocTinh}
                                    inputProps={{
                                      ref: register,
                                      name:
                                        "ListHangTheChap[0].ThuocTinhTaiSan[" +
                                        index +
                                        "].OptionValue",
                                      onChange: onChangeThuocTinhTaiSan(index),
                                      value: ThuocTinhTaiSan[index].OptionValue,
                                    }}
                                  ></TextInputOnRow>
                                  <input
                                    type="hidden"
                                    name={
                                      "ListHangTheChap[0].ThuocTinhTaiSan[" +
                                      index +
                                      "].OptionName"
                                    }
                                    value={item.MaThuocTinh}
                                    ref={register}
                                  ></input>
                                </div>
                              ))}

                            <div className="col-md-3">
                              <div className="form-group">
                                <label className="label-control color7-bold">
                                  Kho
                                </label>
                                <select
                                  name="ListHangTheChap[0].StoreID"
                                  className="selectBox form-control input-sm select-v2"
                                  ref={register}
                                  value={StoreID}
                                  onChange={setAttTaiSan("StoreID")}
                                >
                                  {objComboStore &&
                                    objComboStore.map((item, idx) => (
                                      <option
                                        key={"objComboStore1" + idx}
                                        value={item.value}
                                      >
                                        {item.label}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Mã tài sản"
                                inputProps={{
                                  ref: register,
                                  name: "ListHangTheChap[0].Code",
                                  onChange: setAttTaiSan("MaTaiSan"),
                                  value: MaTaiSan,
                                }}
                              ></TextInputOnRow>
                            </div>
                            {ConfigPhiKho === 1 && (
                              <div className={"col-md-3 "}>
                                <div className="form-group">
                                  <label className="label-control color7-bold">
                                    Phí kho/ngày
                                  </label>
                                  <NumberFormat
                                    thousandSeparator={true}
                                    prefix={""}
                                    inputMode="numeric"
                                    className="form-control input-sm"
                                    placeholder="%"
                                    name="ListHangTheChap[0].PhiKho"
                                    onChange={setAttTaiSan("PhiKho")}
                                    value={PhiKho}
                                    getInputRef={register}
                                  />
                                </div>
                              </div>
                            )}

                            <div
                              className="col-md-12"
                              style={{ marginTop: "10px" }}
                            >
                              <div className="form-group">
                                <label className="label-control color7-bold">
                                  Ghi chú
                                </label>
                                <textarea
                                  rows="1"
                                  style={{ minHeight: "80px" }}
                                  className="form-control input-sm text-era"
                                  name="ListHangTheChap[0].Note"
                                  placeholder="Ghi chú"
                                  ref={register}
                                  onChange={setAttTaiSan("Note")}
                                  value={NoteTaiSan}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 mt-1">
                          <div className="row">
                            <div className="col-md-12">
                              <UploadMultiFile
                                Files={imageTaiSans}
                                onChange={setImageTaiSans}
                                Code={thongTinCuaHang.Code}
                              ></UploadMultiFile>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group overflow-hidden form-actions text-right">
                      <button
                        type="button"
                        className="btn-them-moi-ts"
                        onClick={() => onClickShowAddNewTaiSan(true)}
                        style={{ margin: "0px" }}
                      >
                        <i className="mdi mdi-plus"></i>{" "}
                        <span style={{ fontSize: "15px" }}>
                          Thêm tài sản khác
                        </span>
                      </button>
                    </div>
                    <div className={showAddNewTaiSan ? "" : "hidden"}>
                      <ListTaiSanForm
                        comboLoaiTaiSan={ListLoaiTaiSan}
                        getThuocTinhTaiSan1={getThuocTinhTaiSan1}
                        listTaiSan={ListTaiSanCamCo}
                        onChange={onChangeListTaiSan}
                        thuoctinhtaisan={thuoctinhtaisan}
                        objComboStore={objComboStore}
                        cauHinhPhiKho={PhiKho}
                        codeCuaHang={thongTinCuaHang.Code}
                      ></ListTaiSanForm>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                <div
                  id="headingCollapse191191"
                  className="card-header  mt-1"
                  data-toggle="collapse"
                  href="#collapse191191"
                  aria-expanded="false"
                  aria-controls="collapse194"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Đính kèm file</h3>
                  </a>
                </div>
                <div
                  id="collapse191191"
                  role="tabpanel"
                  aria-labelledby="headingCollapse9412"
                  className="card-collapse collapse"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12 col-lg-12">
                          <UploadMultiFile1
                            Files={fileDinhKems}
                            onChange={setFileDinhKems}
                            Code={thongTinCuaHang.Code}
                          ></UploadMultiFile1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          <button className="btn btn-new-main btn-checknew" type="submit">
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            {camdo_sudungchoduyet ? "Chờ duyệt" : "Lưu lại"}
          </button>
          {/* {showButtonIn && (
            <button
              className="btn btn-new-main btn-checknew"
              href={() => false}
              onClick={inHopDong(choVayEdit)}
              type="button"
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-printer"></i>
              </span>{" "}
              In hợp đồng
            </button>
          )}

          {showButtonInPhieuThu && (
            <button
              className="btn btn-new-main btn-checknew"
              href={() => false}
              onClick={inPhieuThu(ThuChiId)}
              type="button"
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-printer"></i>
              </span>{" "}
              In phiếu thu
            </button>
          )} */}

          <button
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={closeThemMoi()}
            type="button"
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </button>
        </Modal.Footer>

        {isShowModalThuocTinhGiamTru && (
          <>
            <ThuocTinhGiamTruModal
              show={isShowModalThuocTinhGiamTru}
              data={ListThuocTinhGiamTru}
              giagoivay={GiaGoiVay}
              setGiaGoiVay={setGiaGoiVay}
              giasanpham={GiaSanPham}
              setGiaSanPham={setGiaSanPham}
              listThuocTinhGiamTruSelect={ListThuocTinhGiamTruSelect}
              setListThuocTinhGiamTruSelect={setListThuocTinhGiamTruSelect}
              setTongTienGiamTruSelect={setTongTienGiamTruSelect}
              onHide={setModalThuocTinhGiamTru}
            ></ThuocTinhGiamTruModal>
            <div
              style={{
                height: "100%",
                width: "100%",
                backgroundColor: "#000000",
                margin: "0px",
                position: "fixed",
                top: "0",
                left: "0",
                opacity: "0.7",
              }}
            ></div>
          </>
        )}
      </form>
    </Modal>
  );
};
export default ChoVayForm;
